import * as jsxRuntime from "/home/jenkins/agent/workspace/epb-only-nodejs-4727f9e8-5eb1-4f0c-97b2-b9299c650483/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment